var endpointConstant = require('endpoint/endpoint-constant.js');

/**
 * This sevice generate an endpoint string
 * ie: var urlReports =  endpointService.generateEndpoint('institutionReport');
 */
var EndpointService = (function (endpointConstant) {

    'use strict';

    /**
     * Generate an endpoint using a specific host
     */
    var generateEndpoint = function(endpoint, host) {

        var _host = host || currentHost;
        var baseUrl = endpointConstant.hosts[_host];
        var endpointUrl = endpointConstant.endpoints[endpoint];

        return baseUrl + endpointUrl;

    };

    /**
     * Returns a given endpoint
     */
    var getAbsoluteEndpoint = function(endpoint){

        // If env is prod, aim the Zuora Production API.
        if( (endpoint === 'zuoraAPI') && (currentHost === 'production') ){
            endpoint = 'zuoraProdAPI';
        }

        return endpointConstant.absoluteEndpoints[endpoint];
    };

    /**
     * Private vars
     */
    var currentHost = "production";

    /**
     * Public methods
     */
    return {
        generateEndpoint: generateEndpoint,
        getAbsoluteEndpoint: getAbsoluteEndpoint
    };

})(endpointConstant);

module.exports = EndpointService;
